// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AccordionContent_wrap__mrcgS","open":"AccordionContent_open__kIo_t"};